import React from 'react';
import gql from 'graphql-tag';

import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';

import { 
  CorePriceGuideCspData,
} from '@reverbdotcom/commons/src/rql';

import { ChildProps } from 'react-apollo';

import V2CSPPriceGuideModuleLayout from './v2_csp_price_guide_module_layout';

type IProps = ChildProps<IExternalProps, CorePriceGuideCspData.Query>;

interface IExternalProps {
  cspSlug: string;
}

export function V2CSPPriceGuideModuleLayoutContainer({ data }: IProps) {
  const { loading, csp } = data;

  if (loading) return null;

  return <V2CSPPriceGuideModuleLayout csp={csp} />;
}

export const PriceGuideCspFragment = gql`
  fragment PriceGuideCspData on CSP {
    _id
    id
    slug
    title
    variants {
      id
      name
    }
  }
`;
export const withQuery = withGraphql<IProps, CorePriceGuideCspData.Query>(
  gql`
    query Core_PriceGuide_CspData(
      $cspSlug: String
    ) {
      csp(input: {
        slug: $cspSlug
      }) {
        _id
        ...PriceGuideCspData
      }
    }
    ${PriceGuideCspFragment}
  `,
  {
    options: ({ 
      cspSlug,
    }) => {  
      return {
        ssr: false,
        fetchPolicy: 'network-only',
        variables: {
          cspSlug,
        },
      };
    },
  },
);

export default withQuery(V2CSPPriceGuideModuleLayoutContainer);
